import { render, staticRenderFns } from "./gateway-type-form.vue?vue&type=template&id=551b5935&scoped=true&"
import script from "./gateway-type-form.vue?vue&type=script&lang=js&"
export * from "./gateway-type-form.vue?vue&type=script&lang=js&"
import style0 from "./gateway-type-form.vue?vue&type=style&index=0&id=551b5935&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551b5935",
  null
  
)

export default component.exports